export default "__VITE_ASSET__CW5ua0Jh__"